import React, { useContext } from "react";
import styled from "styled-components";
import moment from "moment";
import AdvertisingCard from "./AdvertisingCard";
import {
    Button,
    CardTableCell,
    CardTableCellHeader,
    CardTableRow,
    LottieLoadingIndicator
} from "src/components";
import Checkbox from "src/scenes/EmployeeList/components/Checkbox";
import { FILTER_BY } from "../Advertising";
import { AdContext } from "../AdContext";

const AdvertisingRow = styled(CardTableRow).attrs({
    columns: "2.25rem minmax(8rem, 0.75fr) minmax(12rem, 1fr) minmax(16rem, 1.35fr) minmax(14rem, 1.1fr) minmax(10rem, 0.85fr)",
    minWidth: "1040px"
})``;

const DateLabel = styled.div`
    text-align: left;
    font-family: Manrope, Helvetica, sans-serif;
    font-size: 15px;
    font-weight: 500;
    color: #000000;
    opacity: 1;
    
`;

const EditButton = styled(Button)`
    border-radius: 10px !important;
    width: 160px;
    padding: 11px 16px !important;
    color: #000000;
    background-color: #ffffff;
    cursor: pointer;
    font-size: 14px;
    font-weight: 700;
    text-align: center;
    align-items: center;
    border: 1px solid #000000;
`;

const DisplayViews = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    font-family: Manrope, Helvetica, sans-serif;
    border: 1px solid #2D3037;
    height: 39px;
    width: 160px;
    cursor: pointer;
    letter-spacing: 0.35px;
    align-items: center;
    color: white;
    background: #000000;
    border-radius: 7px;
    color: #FFFFFF;
    font-size: 14px;
`;

const DisplayClicks = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    font-family: Manrope, Helvetica, sans-serif;
    border: 1px solid #2D3037;
    height: 39px;
    width: 160px;
    cursor: pointer;
    letter-spacing: 0.35px;
    align-items: center;
    color: white;
    background: #000000;
    border-radius: 7px;
    color: #FFFFFF;
    font-size: 14px;
`;

const DatePostedLabel = ({ status }) => {
    if (status === FILTER_BY.ACTIVE_ADS) {
        return <div style={{ color: "#000000" }}>Date Posted</div>;
    } else if (status === FILTER_BY.SCHEDULED_ADS) {
        return <div style={{ color: "#171A22" }}>Scheduled</div>;
    } else if (status === FILTER_BY.COMPLETED_ADS) {
        return <div style={{ color: "#000000" }}>Date Published</div>;
    }
};

const DatePostedContent = ({ dateToUse }) => {
    return (
        <div>
            {moment(dateToUse).format("Do MMMM YYYY")}
            <br/>
            {moment(dateToUse).format("hh:mma")}
        </div>
    );
};

function AdvertisingContent({ advertisingArray, checkedAds, handleCheckboxChange, handleShowAdsViewershipModal, handleEditAd }) {
    const { handleShowAdvertisementViewershipModal, handleShowAdvertisementClicksModal } = useContext(AdContext);
    return advertisingArray.map((ad, index) => {
        const isActive = checkedAds.includes(ad.uuid);
        return (
            <AdvertisingRow key={ad.uuid || index} selected={isActive}>
                <CardTableCell>
                    <CardTableCellHeader>
                        <label>
                            <Checkbox
                                readOnly={false}
                                checked={isActive}
                                onChange={() => handleCheckboxChange(ad.uuid)}
                            />
                        </label>
                    </CardTableCellHeader>
                </CardTableCell>
                <CardTableCell>
                    <CardTableCellHeader>
                        <DatePostedLabel status={ad.status} /> 
                    </CardTableCellHeader>
                    <div style={{ display: "flex", height: "80%", flexDirection: "column", justifyContent: "space-between", alignItems: "flex-start" }}>
                        <DateLabel>
                            <DatePostedContent dateToUse={ad.startsAt} />
                            { ad.status === FILTER_BY.COMPLETED_ADS &&
                                <div style={{ marginTop: "15px" }}>
                                    <CardTableCellHeader>
                                        Date Ended
                                    </CardTableCellHeader>
                                    <DatePostedContent dateToUse={ad.endsAt} />
                                </div>
                            }
                        </DateLabel>
                    </div>
                </CardTableCell>
                <CardTableCell>
                    <CardTableCellHeader>
                        <div>Headline</div>
                    </CardTableCellHeader>
                    <AdvertisingCard content={ad.headline} ></AdvertisingCard>
                </CardTableCell>
                <CardTableCell>
                    <CardTableCellHeader>
                        <div>Description</div>
                    </CardTableCellHeader>
                    <AdvertisingCard content={ad.description} ></AdvertisingCard>
                </CardTableCell>
                <CardTableCell>
                    {
                        ad.primaryAsset.pendingMedia && ad.primaryAsset.assetType !== "image" ? (

                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: "100%",
                                    height: "140px",
                                    backgroundColor: "#f5f5f5",
                                    color: "#888",
                                    fontSize: "14px",
                                    fontStyle: "Manrope",
                                    border: "1px solid #D8DEEC",
                                    borderRadius: "8px",
                                }}
                            >
                                <span>Processing video...</span>
                                <div style={{ width: "30px", height: "30px", display: "flex", alignItems: "center" }}>
                                    <LottieLoadingIndicator width="50px" height="50px" />
                                </div>
                            </div>
                        ) : (
                            <>
                                <CardTableCellHeader>
                                    <div>{ad.primaryAsset.assetType === "image" ? "Image" : "Video" }</div>
                                </CardTableCellHeader>
                                <div style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: "100%",
                                    height: "140px",
                                    borderRadius: "8px",
                                    border: "1px solid #D8DEEC",
                                    overflow: "hidden",
                                }}>
                                    <AdAssetPreview ad={ad}/>
                                </div>
                            </>
                        )}
                </CardTableCell>

                <CardTableCell>
                    <CardTableCellHeader>Ad Insights</CardTableCellHeader>
                    <div style={{ display: "flex", height: "140px", flexDirection: "column", justifyContent: "space-around", alignItems: "flex-start" }}>
                        <DisplayViews onClick={() => handleShowAdvertisementViewershipModal(ad)} >{ad.totalViews} Impressions</DisplayViews>
                        <DisplayClicks onClick={() => handleShowAdvertisementClicksModal(ad)} >{ad.totalClicks} Clicks</DisplayClicks>
                        { ad.status !== FILTER_BY.COMPLETED_ADS &&
                            <EditButton onClick={() => handleEditAd(ad)} >View/Edit Ad</EditButton>
                        }
                    </div>
                </CardTableCell>
            </AdvertisingRow>
        );
    });
}

function AdAssetPreview({ ad }) {
    return (
        <>
            {
                ad.primaryAsset.assetType === "image" &&
                <img 
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover"
                    }}
                    src={ad.primaryAsset.assetUrl} 
                    alt={ad.headline}
                />
            }
            
            { /* Render video content here */
                ad.primaryAsset.assetType === "video" &&
                <video
                    controls
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover"
                    }}
                >
                    <source src={ad.primaryAsset.assetUrl} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            }
        </>
    );
}
export default AdvertisingContent;
